// extracted by mini-css-extract-plugin
export default {"button":"FooterElem_button__dqTLx","logo_decor":"FooterElem_logo_decor__e-7yh","custom_hover":"FooterElem_custom_hover__qk+OZ"};